const apiHost = "https://api.design-tool.meshplusplus.com/api";
// const apiHost = "http://localhost:3001/api";
const googleAPIKey = "AIzaSyCGnoASmLh2aGqkv0hs-dpYaLReMZ_moLk";
const googleLibraries = ['geometry'];
const isIframe = true;
export {
  apiHost,
  googleAPIKey,
  googleLibraries,
  isIframe,
};

